var map = {
	"./footer.de-CH.json": 1053,
	"./footer.de-DE.json": 1054,
	"./footer.en-CA.json": 1055,
	"./footer.en-GB.json": 1056,
	"./footer.en-IN.json": 1057,
	"./footer.en-ME.json": 1058,
	"./footer.en-US.json": 1059,
	"./footer.es-EM.json": 1060,
	"./footer.es-ES.json": 1061,
	"./footer.fr-BE.json": 1062,
	"./footer.fr-CA.json": 1063,
	"./footer.fr-CH.json": 1064,
	"./footer.nl-BE.json": 1065,
	"./footer.nl-NL.json": 1066,
	"./footer.pl-PL.json": 1067,
	"./footer.pt-BR.json": 1068
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1052;